import { Button } from '@mui/material';
import { FormControlProps, FormElementControlPropsType } from './index';
import React, { useEffect, useState } from 'react';
import IconHandler, { IconType } from 'components/common/icon/IconHandler';
import { FormComponentBuilder } from 'components/common/form/layout';

export interface FormControlStateButtonProps extends FormControlProps {
    defaultText: string;
    defaultIcon?: IconType;
    activeText?: string;
    activeState?: boolean;
    activeIcon?: IconType;
    dirtyIgnore?: boolean;
}

export default function FormStateButton({ controlProps }: FormElementControlPropsType<FormControlStateButtonProps>) {
    const [active, setActive] = useState<boolean>(!!controlProps.activeState);

    const getIcon = () => {
        const iconData = active ? (controlProps.activeIcon ?? controlProps.defaultIcon) : controlProps.defaultIcon;
        if (!iconData) return undefined;

        return <IconHandler icon={iconData} />;
    };

    useEffect(() => {
        controlProps.form.hookFormSetValue(controlProps.name, active ? 'Y' : 'N', {
            shouldDirty: !controlProps.dirtyIgnore,
        });
    }, [active]);

    return (
        <Button
            data-test={controlProps.uid}
            name={controlProps.name}
            onClick={() => {
                setActive(!active);
            }}
            variant="light"
            startIcon={getIcon()}
        >
            {active ? (controlProps.activeText ?? controlProps.defaultText) : controlProps.defaultText}
        </Button>
    );
}

export class FormStateButtonBuilder extends FormComponentBuilder {
    prepareProps(): FormControlStateButtonProps {
        return {
            ...this.controlProps,
            defaultValue: this.elementProps.componentProps?.activeState ? 'Y' : 'N',
            defaultText: this.elementProps.componentProps?.defaultText ?? 'Show',
            defaultIcon: this.elementProps.componentProps?.defaultIcon,
            activeText: this.elementProps.componentProps?.activeText ?? 'Hide',
            activeIcon: this.elementProps.componentProps?.activeIcon,
            activeState: this.elementProps.componentProps?.activeState ?? false,
            dirtyIgnore: this.elementProps.componentProps?.dirtyIgnore ?? true,
        };
    }
}
